






import { createComponent } from "@vue/composition-api";

interface Props {}

export default createComponent<Props>({
  components: {},
  props: {},
  setup(props, ctx) {
    return {};
  },
});
